import React from 'react';
import { FaFacebookF, FaInstagram, FaTwitter, FaLinkedinIn, FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock, FaTiktok } from 'react-icons/fa';
import './footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-main">
          {/* Company Info */}
          <div className="footer-section">
            <img src='/Alutech Alumium.png' alt="Company Logo" className="footer-logo" /> 
            <br />
            {/* <h3 className="footer-title">Innovative Pre Fab Technology</h3> */}
            <p className="footer-description">
              INNOVATIVE PRE-FAB TECHNOLOGY is committed to provide the very best to 
              achieve high performance and the quality of our services. 
              We embrace the principals of continuous improvement in product 
              innovation, quality, reliability and good customer service.  
            </p>
            <div className="social-links">
<a
  href="https://www.facebook.com/profile.php?id=61586794041542"
  className="social-link"
  aria-label="Facebook"
  target="_blank"
  rel="noopener noreferrer"
>
  <FaFacebookF className="social-icon" />
</a>

              {/* <a href="#" className="social-link" aria-label="Instagram">
                <FaInstagram className="social-icon" />
              </a> */}
              {/* <a href="https://www.tiktok.com/@retionzcabs" className="social-link" aria-label="Twitter">
                <FaTiktok className="social-icon" />
              </a> */}
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-subtitle">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="/">Home</a></li>
              <li><a href="ourwork">Our Work</a></li>
              <li><a href="/aboutus">About Us</a></li>
              <li><a href="/contactus">Contact Us</a></li>
               <li><a href="/get-a-quote">Get a Quote</a></li>
            </ul>
          </div>



          





          {/* Services */}
          <div className="footer-section">
            <h4 className="footer-subtitle">Our Services</h4>
            <ul className="footer-links">
               <li><a href="/Pre fab warehouse building">Pre Fab Warehouse Building</a></li>
               <li><a href="/aluminum-window">Aluminium Windows</a></li>
               <li><a href="/curtain-walls">Curtain Walls</a></li>
              <li><a href="/partition" >Partition</a></li>
              <li><a href="/aluminium-pantry">Aluminium Pantry Cupboards</a></li>
              <li><a href="/wall-cladding">Wall Cladding</a></li>
              <li><a href="/roof-and-ceiling" >Polycarbonate Sheet Roofs & Canopies Ceilings</a></li>
              <li><a href="/glass-door-glass-partition">Glass Partition, Glass Doors & Windows</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4 className="footer-subtitle">Contact Information</h4>
            <div className="contact-info">
              <div className="contact-item">
                <FaMapMarkerAlt className="contact-icon" />
                <span>No: 318/1, Colombo Road, Bokundara, Piliyandala, Sri Lanka </span>
              </div>
      <div className="contact-item">
  <FaPhone className="contact-icon" />
  <a href="tel:+94777324632" className="contact-link">+94 77 732 4632</a>
</div>

      <div className="contact-item">
  <FaPhone className="contact-icon" />
  <a href="tel:+94719566805" className="contact-link">+94 71 956 6805</a>
</div>

 
<div className="contact-item">
  <FaEnvelope className="contact-icon" />
  <a href="mailto:info@retionzcabs.lk" className="contact-link">info@innovativeprefab.lk</a>
</div>

              <div className="contact-item">
                <FaClock className="contact-icon" />
                <span>08:00 AM - 05:00 PM</span>
              </div>
            </div>
          </div>
        </div>

        {/* Newsletter Subscription
        <div className="newsletter-section">
          <div className="newsletter-content">
            <h4 className="newsletter-title">Subscribe to Our Newsletter</h4>
            <p className="newsletter-description">
              Get the latest offers and travel updates
            </p>
            <div className="newsletter-form">
              <input 
                type="email" 
                placeholder="Enter your email address"
                className="newsletter-input"
              />
              <button className="newsletter-btn">Subscribe</button>
            </div>
          </div>
        </div> */}

        {/* Footer Bottom */}
        <div className="footer-bottom-cab">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>© {new Date().getFullYear()} Innovative Pre Fab Technology. All Rights Reserved. | Designed and Developed by 
                <a 
                  className="glaxmore-link" 
                  href="https://www.glaxmore.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  &ensp; GLAXMORE
                </a>
              </p>
            </div>
  
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;